export class NeoConfigAccessLevel {
  static readonly NeoUser = 'neo-user';
  static readonly NeoAdmin = 'neo-admin';
  static readonly NeoSuperAdmin = 'neo-super-admin';
}

export class NeoConfigDataType {
  static readonly Text = 'text';
  static readonly Boolean = 'boolean';
  static readonly Number = 'number';
  static readonly DateTime = 'DateTime';
  static readonly DateOnly = 'DateOnly';
  static readonly TimeOnly = 'TimeOnly';
  static readonly Json = 'json';
  static readonly Xml = 'xml';
  static readonly EncryptedText = 'encrypted-text';

  // custome data types that allow for specialized handling in the UI
  static readonly TenantFeatureFlagAccessState = 'TenantFeatureFlagAccessState';
  static readonly TenantMigrationState = 'TenantMigrationState';
  static readonly LevelDisplayDetails = 'LevelDisplayDetails';
  static readonly FieldMappings = 'FieldMappings';

}

export interface NeoConfig {
  id: string;
  tenantKey: string;
  key: string;
  label: string;
  dataType: string;
  data: string;
  accessLevel: string;
  createdDate: Date;
  modifiedDate: Date;
}

export interface NeoConfigFilter {
  id?: string | null;
  tenantKey?: string | null;
  key?: string | null;
  keyComparer?: string;
  label?: string | null;
  labelComparer?: string;
  dataType?: string | null;
  data?: string | null;
  accessLevel?: string | null;
  createdDateFrom?: Date | null;
  createdDateTo?: Date | null;
  modifiedDateFrom?: Date | null;
  modifiedDateTo?: Date | null;
}
